<style lang="less">
@import "../../../styles/common.less";
</style>
<template>
  <div class="certList">
    <div class="img-title">
      <img src="@/assets/tip.png" />
      <span>截取网页后，及时上传至区块链司法存证，即可永久固定证据</span>
    </div>
    <div class="table-list" style="position:relative">
      <div class="table-list-title">
        <span style="margin-left:25px">取证列表</span>      
      </div>
      <Row class="table-style-size">
        <i-col span="4">页面截图</i-col>
        <i-col span="6">证据信息</i-col>
        <i-col span="3">截取时间</i-col>
        <i-col span="3">证书</i-col>
        <i-col span="3">状态</i-col>
        <i-col span="5">操作</i-col>
      </Row>
      <Row class="table-style-other" v-for="(item,index) in records" :key="index">                   
        <i-col span="4" v-if="item.screenshotUrl==''||item.screenshotUrl==null"><img src="@/assets/defalut.png" class="screen-img" /></i-col>
        <i-col span="4" v-else><img :src="item.screenshotUrl+'?x-image-process=image/resize,m_fixed,w_135,h_85'" class="screen-img" /></i-col>      
        <i-col span="6">
          <Tooltip :content="item.name" placement="top"><p class="notwrap" style="margin-bottom:7px;width:333px">{{item.name}}</p></Tooltip>
          <Tooltip :content="item.url" placement="top"><p class="notwrap" style="color:#4E8CEE;text-decoration:underline;width:333px">{{item.url}}</p></Tooltip>
        </i-col>
        <i-col span="3">{{item.createDate}}</i-col>
        <i-col span="3" v-if="item.evidenceOrder.status=='证书已生成'"><a :href="item.evidenceOrderExtends.certSignaturePdfUrl"  target="_black"><img src="@/assets/evidence-open.png" class="inco-img" /></a></i-col>
        <i-col span="3" v-else><img src="@/assets/evidence-close.png" class="inco-img" /></i-col>
        <i-col span="3">{{item.evidenceOrder.status}}</i-col>
        <i-col span="5">
            <button class="btnborder-84" @click="pushInfo(item)" v-if="item.evidenceOrder.status!='取证失败'">详情</button>
            <button class="btnborder-84" @click="againSubmit(item.id)" v-if="item.evidenceOrder.status=='取证失败'">重新截取</button>
            <div class="showphotow" v-if="item.evidenceOrder.status=='证书已生成'">
                <button class="btnborder-84">更多操作</button>
                <div class="showdiasy">
                    <p @click="openVerify(item.orderSeqNo)">证书核验</p>
                    <p @click="downBook(item.orderSeqNo)"><a :href="item.evidenceOrderExtends.certSignaturePdfUrl"  target="_black">下载证书</a></p>
                    <p @click="downUrl(item)">下载数据包</p>
                    <p @click="downBcBook(item.orderSeqNo)">下载BC文件</p>
                </div>
            </div> 
        </i-col>
      </Row>
      <div class="commont-page" style="position:absolute;bottom:30px;left:50%;transform:translate(-50%, -50%)">
        <Page :page-size="pageSize"  @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page><span class="page-total-span">/&nbsp;{{pages}}页</span>
      </div>
    </div>
  </div>
</template>

<script>
import { _getByPage ,_getresave} from "@/api/evidence.js";
import Cookies from "js-cookie";
export default {
  metaInfo: {
      title: '取证列表|时尚知识产权保护平台',
      meta: [{                 // set meta
          name: 'keyWords',
          content: ''
      },{
          name: 'Description',
          content: ''
      }]
  },
  name: "evidenceList",
  data(){
    return{
      total:0,
      pages:0,
      pageNumber:1,
      pageSize:5,
      records:[],
      flag:'f1'
    }
  },
  methods: {
      getByPage(){  
        let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
        const data = {
          pageNumber:this.pageNumber,
          pageSize:this.pageSize,
          sort:'create_date',
          order:'desc',
          registerId:userInfo && userInfo.id?userInfo.id:'',
        }
        _getByPage(data).then(res => {
          if(res.code==200){
            this.total=Number(res.result.total);
            this.pages=res.result.pages;
            this.records=res.result.records
          }
        });
               
      },
      //证据包
      downUrl(item){
         if (item.packageUrl) {
            const links = item.packageUrl;
            let aDom = document.createElement("a");
            aDom.target = "_self";
            aDom.href = links;
            aDom.download = links.substr(links.lastIndexOf('/'), links.length);
            aDom.click();
        }
      },
       //下载Bc
      downBcBook(id){
        window.open( this.API_ROOT_UPLOAD + "bqjvip/blockChain/tianPing/downloadBc?evidenceOrderSeqNos=" + id, '_self');
      },
      //分页
      changepage(index){
          this.pageNumber = index
          this.getByPage()
      },
      //详情
      pushInfo(item){
        this.$router.push({name:'evidenceInfo',query: {id:item.id}})
      },
      //证书核验
      openVerify(val){
        // let routeUrl = this.$router.resolve({
        //   path: "/index/creation_verification",
        //   name:'creationVerification',
        //   params: {type:this.flag,id:val}
        // });
        // window.open(routeUrl.href, '_blank');
        window.open(this.API_ROOT_UPLOAD+"verification/" + this.flag+'/'+val, '_blank');
      },
      //重新截取
      againSubmit(val){
        // this.$router.push({name:'evidenceWeb',query: {id:val}})
        this.getRequest('/evidenceWebpage/get/'+val).then(res=>{
            if(res.code==200){
                let orderSeqNo=res.result.orderSeqNo;
                _getresave({orderSeqNo:orderSeqNo}).then(res => {
                    if(res.code==200){
                        this.getByPage()
                    }else{
                         toast(res.message)
                    }
                });               
            }else{
                toast(res.message)
            }
        })
      }
  },
  mounted() {
    this.getByPage()
  },
};
</script>

<style scoped lang="less">
.table-style-other{
  width:1334px;
  height:105px;
  background:rgba(255,255,255,1);
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom:1px solid #F7F9FB;
  div{
    text-align: center;
    font-size: 14px;
    color:rgba(102,102,102,1);
  }
  .screen-img{
    width:135px;
    height: 85px;
  }
  .inco-img{
    height: 20px;
    width:20px;
  }
}
.showphotow{
    display: inline-block;
    height: 100%;
    position:relative;
    margin-left: 20px;
    .showdiasy{
      position:absolute;
      top:35px;
      left:0px;
      background: #fff;
      box-shadow: 0 2px 18px 0 rgba(179,189,199,.47);
      border-radius: 4px;
      z-index:777;
      width: 110px;
      display:none;
      p{
        height:30px;
        line-height:30px;
        cursor:pointer;
        font-size: 12px;
        background-color: #fff;
        color: #929292;
      }
      a{
        color: #929292;
      }
      a:hover{
        color: #4e4e4e;  
      }
      p:hover{
        background-color: #f7f9fb;
        color: #4e4e4e;
      }
    }
    &:hover{
      .showdiasy{
        display:block;
      }
    }
  }
  .btnborder-84{
    width:96px;
    height:33px;
    line-height: 33px;
    background: transparent;
    border:1px solid rgba(239,239,239,1);
    outline: none;
    cursor: pointer;
    font-size:12px;
    font-weight:400;
    color:rgba(51,51,51,0.6);
  }
  .btnborder-84:hover{
    border:1px solid rgba(18,18,16,1);
    color:rgba(51,51,51,1);
  }
</style>
